
import { products, Product } from "@/components/shop/ShopTypes";

interface ProductMatch {
  product: Product;
  score: number;
}

// Properties for different product types based on quiz answers
const productProperties: Record<number, Record<string, string[]>> = {
  // Product IDs matching skin types
  1: { // Question 1: Skin type
    normal: ["1", "3", "4", "9"],
    sensitive: ["2", "4", "5", "9"],
    dry: ["2", "4", "5"],
    oily: ["1", "3", "7", "9"]
  },
  2: { // Question 2: Sweat amount
    minimal: ["2", "5", "9"],
    light: ["1", "2", "5", "9"],
    heavy: ["3", "4", "7", "9"],
    extreme: ["3", "4", "6", "7"]
  },
  3: { // Question 3: Natural preference
    yes: ["2", "4", "5", "9"],
    no: ["1", "3", "6", "7", "8"],
    neutral: ["1", "2", "3", "4", "5", "6", "7", "8", "9"]
  },
  4: { // Question 4: Scent preference
    fresh: ["1", "4", "9"],
    floral: ["2", "5"],
    fruity: ["4", "5"],
    earthy: ["3", "4"],
    unscented: ["2", "3"]
  },
  5: { // Question 5: Irritation frequency
    often: ["2", "4", "5", "9"],
    sometimes: ["2", "3", "4", "5", "9"],
    never: ["1", "2", "3", "4", "5", "6", "7", "8", "9"]
  },
  6: { // Question 6: Concerns (multiple choice)
    stain_free: ["2", "3", "4", "5"],
    aluminum_free: ["2", "3", "4", "5", "9"],
    vegan: ["2", "3", "4", "5", "9"],
    long_lasting: ["1", "3", "4", "9"],
    none: ["1", "2", "3", "4", "5", "6", "7", "8", "9"]
  }
};

export const findMatchingProducts = (answers: Record<number, string | string[]>): Product[] => {
  const productMatches: ProductMatch[] = products.map(product => ({
    product,
    score: 0
  }));

  // Calculate match scores for each product
  for (const [questionId, answer] of Object.entries(answers)) {
    const qId = parseInt(questionId);
    
    if (Array.isArray(answer)) {
      // For multiple choice questions
      if (answer.includes("none")) {
        // If "none" is selected, all products get points for this question
        productMatches.forEach(match => match.score += 1);
      } else {
        answer.forEach(value => {
          const matchingProductIds = productProperties[qId][value] || [];
          productMatches.forEach(match => {
            if (matchingProductIds.includes(String(match.product.id))) {
              match.score += 1;
            }
          });
        });
      }
    } else {
      // For single choice questions
      const matchingProductIds = productProperties[qId][answer] || [];
      productMatches.forEach(match => {
        if (matchingProductIds.includes(String(match.product.id))) {
          match.score += 1;
        }
      });
    }
  }

  // Sort by score and get top matches
  const sortedMatches = productMatches
    .sort((a, b) => b.score - a.score)
    .map(match => match.product);

  // Return top 3 matches or fewer if not enough matches
  return sortedMatches.slice(0, 3);
};
